import React from 'react';
import { observer } from 'mobx-react-lite';

import {
    StyledActionButton,
    CheckoutButtonWrapper,
    StyledActionButtonLabel
} from '~views/CartSidebarFooter/CartSidebarFooterStyles';
import CartSidebarViewController from '~exported/CartSidebar/controller/CartSidebarViewController';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import { classes } from '~utils/ClassNames';

interface IActionButton {
    url?: string;
    label: string;
    children?: React.ReactChild;
    disabled?: boolean;
    //eslint-disable-next-line
    fn?(): any;
}

const buttonClass = classes('cart-page-checkout-btn');
const wrapperButtonClass = classes('cart-page-checkout-btn-wrapper');
const buttonLabelClass = 'elc-cart-page-checkout-btn-label';

const ActionButton = observer(({ url, label, fn, disabled, children }: IActionButton) => {
    const { redirectClick }: CartSidebarViewController = diContainer.get(
        serviceNames.cartSidebarViewController
    );

    const onClick = async () => {
        if (url) {
            const _url = fn ? await fn?.() : url;
            redirectClick(_url);
        } else if (fn) {
            await fn?.();
        }
    };

    return (
        <CheckoutButtonWrapper className={wrapperButtonClass}>
            <StyledActionButton
                className={buttonClass}
                disabled={disabled}
                onClick={onClick}
                value={label}
                type="button"
            >
                {children}
                <StyledActionButtonLabel className={buttonLabelClass}>
                    {label}
                </StyledActionButtonLabel>
            </StyledActionButton>
        </CheckoutButtonWrapper>
    );
});

export default ActionButton;
